<h2 mat-dialog-title>Compose PAYG Email</h2>

<mat-dialog-content class="email-dialog">

  <!-- Summary -->

  <div class="summary-card">

    <div class="summary-title">
      Recipients Selected
    </div>

    <div class="summary-count">
      {{ selectedRecipients.length }}
    </div>

  </div>

  <!-- Subject -->

  <mat-form-field appearance="outline" class="full-width">

    <mat-label>Subject</mat-label>

    <input matInput
           [(ngModel)]="subject"
           maxlength="250">

  </mat-form-field>

  <!-- Body -->

  <mat-form-field appearance="outline" class="full-width">

    <mat-label>Email Body</mat-label>

    <textarea matInput
              rows="16"
              [(ngModel)]="body">

    </textarea>

  </mat-form-field>

  <!-- Variables -->

  <div class="variable-section">

    <div class="section-title">

      Available Variables

    </div>

    <mat-chip-listbox>

      <mat-chip-option (click)="insertVariable('[BENEFICIARY_NAME]')">

        BENEFICIARY_NAME

      </mat-chip-option>

      <mat-chip-option (click)="insertVariable('[URN]')">

        URN

      </mat-chip-option>

      <mat-chip-option (click)="insertVariable('[EMAIL]')">

        EMAIL

      </mat-chip-option>

      <mat-chip-option (click)="insertVariable('[PROBATE_ID]')">

        PROBATE_ID

      </mat-chip-option>

      <mat-chip-option (click)="insertVariable('[ISSUE_DATE]')">

        ISSUE_DATE

      </mat-chip-option>

      <mat-chip-option (click)="insertVariable('[BEQUEST_TYPE]')">

        BEQUEST_TYPE

      </mat-chip-option>

      <mat-chip-option (click)="insertVariable('[ESTATE_VALUE]')">

        ESTATE_VALUE

      </mat-chip-option>

      <mat-chip-option (click)="insertVariable('[BEQUEST_VALUE]')">

        BEQUEST_VALUE

      </mat-chip-option>

      <mat-chip-option (click)="insertVariable('[VERIFICATION_DATE]')">

        VERIFICATION_DATE

      </mat-chip-option>

    </mat-chip-listbox>

  </div>

  <!-- Preview -->

  <div class="preview-section">

    <div class="section-title">

      Preview
      <span class="preview-note">

        (using first selected recipient)

      </span>

    </div>

    <div class="preview-box">

      <!-- Subject -->
      <div class="preview-subject">
        <strong>Subject</strong>
        <div>{{ previewSubject }}</div>
      </div>

      <hr>

      <!-- Email -->
      <div class="email-preview">

        <!-- Header -->
        <div class="email-preview-header">

          <div class="preview-logo">
            Smee<span>&amp;</span>Ford
          </div>

          <div class="preview-tagline">
            Together with Legacy Futures
          </div>

        </div>

        <div class="preview-red-line"></div>

        <!-- Content -->
        <div class="email-preview-content">

          <h1>
            A gift has been left to your charity
          </h1>

          <p class="preview-greeting">
            Hello {{ previewRecipient?.beneficiaryName || '' }},
          </p>

          <!-- Editable message -->
          <p class="preview-message">
            {{ previewBody }}
          </p>

          <!-- Gift Value -->
          <div class="preview-gift-box">

            <div class="preview-label">
              Indicative Gift Value
            </div>

            <div class="preview-gift-value">

              <ng-container *ngIf="previewRecipient?.bequestType === 'Absolute Residual'; else previewCurrency">

                {{ previewRecipient?.bequestValue }}%

              </ng-container>

              <ng-template #previewCurrency>

                {{
 previewRecipient?.bequestValue
                | currency:'GBP':'symbol':'1.0-0'
                }}

              </ng-template>

            </div>

            <div class="preview-bequest-type">
              {{ previewRecipient?.bequestType }}
            </div>

          </div>

          <!-- Payment -->
          <div class="preview-payment">

            <p>
              You can securely pay for this notification using our
              PAYG service. There is no subscription and you only pay
              for the notification you choose to access.
            </p>

            <button type="button"
                    class="preview-pay-button">

              Pay Now and Unlock Documents

            </button>

            <p class="preview-payment-note">
              Once purchased, your organisation will receive the
              requested notification, Will and Grant of Probate
              documents by email.
            </p>

          </div>

          <!-- Who are Smee & Ford -->
          <div class="preview-info-box">

            <h2>
              Who are Smee &amp; Ford?
            </h2>

            <p>
              Smee &amp; Ford helps charities identify and manage
              gifts left to them in Wills.
            </p>

            <ul>

              <li>
                This notification was identified from public
                probate information after probate was granted.
              </li>

              <li>
                We will never ask you to send payment details
                by email.
              </li>

            </ul>

          </div>

          <p class="preview-closing">
            Kind regards,<br>
            The Smee &amp; Ford team
          </p>

        </div>

        <!-- Footer -->
        <div class="email-preview-footer">

          This email was sent because public probate information
          identifies your organisation as a beneficiary.

        </div>

      </div>

    </div>
  </div>

</mat-dialog-content>

<mat-dialog-actions align="end">

  <button mat-button
          mat-dialog-close>

    Cancel

  </button>

  <button mat-stroked-button
          color="primary"
          (click)="updatePreview()">

    Preview

  </button>

  <button mat-raised-button
          color="primary"
          (click)="sendEmails()">

    Send Emails

  </button>

</mat-dialog-actions>
